export const bandMap: Record<string, string> = {
  't3.medium::50::1,1,1': 'Play',
  't4g.medium::50::1,1,1': 'Play',
  'm6g.xlarge::150::3,6,3': 'GA+',
  'm6g.large::70::2,4,2': 'GA',
  'm5.xlarge::150::3,6,3': 'A+',
  'r6g.xlarge::200::4,8,4': 'GB',
  'r6g.2xlarge::300::6,12,6': 'GC',
  'r6g.4xlarge::350::9,18,9': 'GD',
  'r6g.8xlarge::400::12,24,12': 'GE',
  'r6g.12xlarge::500::18,36,18': 'GF',
  'r6g.16xlarge::600::25,50,25': 'GG',
};

export const instanceClass: Record<string, string> = {
  'saas deployment for learn': 'Plus',
  'saas deployment for learn (2015-2016)': '-',
  'saas std deployment for learn': 'Standard',
  'blackboard learn saas advantg': 'Advantage',
};

export const getInstanceClassFromInstanceType = (instanceType: string): string | undefined =>
  instanceClass[instanceType.toLowerCase()] || undefined;

export const getBandFromInstanceType = (instanceType: string): string | undefined =>
  bandMap[instanceType] || undefined;
